import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IPagedResults } from 'src/app/core/models/base';
import { environment } from 'src/environments/environment';
import {
  IClearWorkTimeViolationRequest,
  ISearchWorkTimeViolationsRequest,
  IWorkTimeViolation
} from '../models/work-time-violation';

@Injectable({
  providedIn: 'root'
})
export class WorkTimeViolationService {

  constructor(private http: HttpClient) { }

  searchWorkTimeViolations(request: ISearchWorkTimeViolationsRequest) {
    return this.http.post<IPagedResults<IWorkTimeViolation[]>>(
      `${environment.baseUrl}/v1/WorkTimeViolation/searchWorkTimeViolations`,
      request
    );
  }

  clearWorkTimeViolation(request: IClearWorkTimeViolationRequest) {
    return this.http.put<string>(
      `${environment.baseUrl}/v1/WorkTimeViolation/clearWorkTimeViolation/${request.id}`,
      request
    );
  }
}
